import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { provideRouter, withPreloading } from '@angular/router';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { FIREBASE_OPTIONS } from '@angular/fire/compat'; // Import FIREBASE_OPTIONS
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';
import { tokenInterceptorInterceptor } from './core/interceptors/token-interceptor.interceptor';
import { CustomPreloadingStrategyService } from './core/services/custom-preloading-strategy.service';
import { CrashMonitorService } from './core/services/crash-monitor.service';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(CustomPreloadingStrategyService)),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([tokenInterceptorInterceptor])),
    { provide: ErrorHandler, useClass: CrashMonitorService },

    // Core Firebase App
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    // Optional: Explicitly provide FIREBASE_OPTIONS for compatibility
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },

    // Firestore
    provideFirestore(() => getFirestore()),
    importProvidersFrom(TypeaheadModule.forRoot()),
  ],
};
